import { useContext } from 'react';
import { AuthContext } from '../Contexts/AuthContext';

/**
 * Custom hook to access the authentication context.
 * This hook centralizes the logic for accessing auth-related data and functions,
 * ensuring components use the single source of truth from AuthProvider.
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  // This check ensures that the hook is used within a component tree
  // that is a descendant of the AuthProvider.
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default useAuth;